"use client";

import { Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SuccessStoriesPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative bg-background py-16 px-6 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className={`grid md:grid-cols-2 gap-12 items-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="space-y-6">
            <Quote className="size-12 text-primary/40" aria-hidden="true" />
            <blockquote className="space-y-4">
              <p className="text-2xl md:text-3xl font-display italic text-foreground leading-relaxed">
                "Click Viral transformed our email marketing, boosting our repeat customers significantly."
              </p>
              <footer className="text-base text-muted-foreground">
                <cite className="not-italic font-semibold text-foreground">
                  Jane D.
                </cite>
                {" "}
                — Owner, The Gourmet Bistro
              </footer>
            </blockquote>

            <Link to="/SuccessStoriesPage">
              <Button variant="outline" className="mt-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-accent/10">
                Read More Success Stories
              </Button>
            </Link>
          </div>

          {}
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/email_campaign_dashboard_preview.png" alt="Email campaign dashboard preview showing analytics and performance metrics" className="w-full h-auto object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}